<template>
  <span v-if="brandLogo" class="brand-badge">
    <img
      :src="require(`@/assets/images/common/element-icons-logo-${badge.name}.svg`)"
      :width="badge.width"
      :height="badge.height"
      :alt="`${badge.name} Logo`"
    >
  </span>
</template>

<script>
export default {
  name: 'BrandBadge',
  props: {
    brandLogo: {
      type: String,
      default: null
    }
  },
  computed: {
    badge () {
      let name = ''
      let size = []
      const logo = this.brandLogo.toLowerCase()

      switch (logo) {
        case 'original' :
          name = 'wavve-original'
          size = [ 98, 24 ]
          break
        case 'only' :
          name = 'wavve-only'
          size = [ 68, 24 ]
          break
        case 'bbc' :
          name = 'bbc'
          size = [ 64, 24 ]
          break
        case 'hbomax' :
          name = 'hbomax'
          size = [ 106, 24 ]
          break
        case 'hbo' :
          name = 'hbo'
          size = [ 112, 24 ]
          break
      }

      const [ width, height ] = size
      return { name, width, height }
    }
  }
}
</script>
